/*
 * Abstract class Software
 */
export default class HowItWorks {
    constructor($sce, content, brandColorType, brandCode, landing_page_images) {
        this.sce = $sce;
        this.content = content;
        this.brandColorType = brandColorType;
        this.landing_page_images = landing_page_images;
        this.brandCode = brandCode;
    }

    feature() {
        let features = {
            id_monitoring 	: {
                title 		: this.sce.trustAsHtml(this.content['features-id-monitoring-title']),
                text 		: this.sce.trustAsHtml(this.content['features-id-monitoring-text']),
                icon 		: '<i class="flaticon-globe"></i>',
                svg 		: (this.brandCode === 'ea_gma_ch') ? '#globe-2' : "#globe",
                duration 	: '1s',
                delay 		: '.1s',
                anchor 		: 'id_monitoring',
                description	: {
                    text 		: this.sce.trustAsHtml(this.content['features-id-monitoring-description-text']),
                    image 		: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.globe,
                    background	: 'bg-gray',
                    position 	: 'right',
                    points 		: [
                        this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-1']),
                        this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-2']),
                        this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-3']),
                        this.sce.trustAsHtml(this.content['features-id-monitoring-description-point-4'])
                    ]
                }
            },
            pc_laptop 			: {
                title 		: this.sce.trustAsHtml(this.content['features-pc-laptop-title']),
                text 		: this.sce.trustAsHtml(this.content['features-pc-laptop-text']),
                icon 		: '<i class="flaticon-laptop-1"></i>',
                svg 		: (this.brandCode === 'ea_gma_ch') ? '#laptop-2' : "#laptop-1",
                duration 	: '1s',
                delay 		: '.3s',
                anchor 		: 'pc_laptop_protection',
                description	: {
                    text 		: this.sce.trustAsHtml(this.content['features-pc-laptop-description-text']),
                    image 		: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.laptop,
                    background	: 'bg-gray',
                    position 	: 'left',
                    points 		: [
                        this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-1']),
                        this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-2']),
                        this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-3']),
                        this.sce.trustAsHtml(this.content['features-pc-laptop-description-point-4'])
                    ]
                }
            },
            mobile_protection 	: {
                title 		: this.sce.trustAsHtml(this.content['features-mobile-protection-title']),
                text 		: this.sce.trustAsHtml(this.content['features-mobile-protection-text']),
                icon 		: '<i class="flaticon-smartphone-1"></i>',
                svg 		: (this.brandCode === 'ea_gma_ch') ? '#mobile' : '#smartphone-1',
                duration 	: '1s',
                delay 		: '.5s',
                anchor 		: 'mobile_protection',
                description	: {
                    text 		: this.sce.trustAsHtml(this.content['features-mobile-protection-description-text']),
                    image 		: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.smartphone,
                    background	: 'bg-gray',
                    position 	: 'right',
                    points 		: [
                        this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-1']),
                        this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-2']),
                        this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-3']),
                        this.sce.trustAsHtml(this.content['features-mobile-protection-description-point-4'])
                    ]
                }
            },
            assistance 			: {
                title 		: this.sce.trustAsHtml(this.content['features-assistance-title']),
                text 		: this.sce.trustAsHtml(this.content['features-assistance-text']),
                icon 		: '<i class="flaticon-telemarketer"></i>',
                svg 		: (this.brandCode === 'ea_gma_ch') ? '#assistance' : '#telemarketer',
                duration 	: '1s',
                delay 		: '.7s',
                anchor 		: 'id_assistance',
                description	: {
                    text 		: this.sce.trustAsHtml(this.content['features-assistance-description-text']),
                    image 		: '/images/generali/landing/' + this.brandColorType + '/' + this.landing_page_images.telemarketer,
                    background	: 'bg-gray',
                    position 	: 'left',
                    points 		: [
                        this.sce.trustAsHtml(this.content['features-assistance-description-point-1']),
                        this.sce.trustAsHtml(this.content['features-assistance-description-point-2']),
                        this.sce.trustAsHtml(this.content['features-assistance-description-point-3']),
                        this.sce.trustAsHtml(this.content['features-assistance-description-point-4'])
                    ]
                }
            }
        }

        for (let index in features) {
            features[index].description.icon = `<span class="icon-correct"></span>`;
        }

        return features;
    }
}